export default {
    install(Vue, store) {
        Vue.prototype.$settings = (setting) => {
            if (typeof store.state.settings[setting] !== 'undefined') {
                return store.state.settings[setting];
            }

            return '';
        }
    },
};